import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

type Value = React.ReactNode | (() => React.ReactNode);

type Props = {
  rows: Record<string, Value>;
};

export function Table({ rows }: Props) {
  function formatValue(value: Value) {
    if (typeof value === 'string' || typeof value === 'number') {
      return value;
    }
    return JSON.stringify(value);
  }

  return (
    <table className={styles.table}>
      <tbody>
        {Object.entries(rows).map(([key, value]) => (
          <tr key={key}>
            <td>
              <Body variant="sm-regular">{`${key}:`}</Body>
            </td>
            <td>
              {typeof value === 'function' ? (
                value()
              ) : (
                <code className={styles.rowValue}>{formatValue(value)}</code>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
